import type { Lesson } from '../schema.js';

export const ATTACK_LESSONS: Lesson[] = [
  {
    id: 'attack-the-king',
    slug: 'attack-the-king',
    title: 'Attack the king',
    audienceLevel: 'beginner',
    concepts: ['attack', 'king-safety'],
    steps: [
      {
        kind: 'explain',
        title: 'The king is the target',
        body: 'The whole game is about the king. When the king is trapped by its own pieces, a single powerful check can end the game.',
        narration: 'Attack the king with your strongest pieces.',
      },
      {
        kind: 'demo',
        title: 'Watch a back-rank mate',
        body: 'The black king is boxed in by its own pawns. White slides the queen down the e-file — checkmate!',
        fen: '6k1/5ppp/8/8/8/8/4Q3/6K1 w - - 0 1',
        highlight: { from: 'e2', to: 'e8', check: true },
      },
      {
        kind: 'quiz',
        title: 'Attack check',
        body: 'A quick check on attacking.',
        questions: [
          { prompt: 'When the king is trapped, a check can be:', choices: ['Checkmate', 'Only a pawn move'], correct: 0 },
          { prompt: 'A queen is powerful because:', choices: ['It moves fast and far', 'It is easy to hide'], correct: 0 },
        ],
      },
    ],
  },
  {
    id: 'attack-open-file',
    slug: 'attack-open-file',
    title: 'Attack down open files',
    audienceLevel: 'beginner',
    concepts: ['attack', 'piece-power'],
    steps: [
      {
        kind: 'explain',
        title: 'Rooks love open files',
        body: 'A rook is strongest on an open file — a column with no pawns on it. From there it can sweep into the enemy position and attack the king.',
        narration: 'Put your rooks on open files.',
      },
      {
        kind: 'demo',
        title: 'Watch the rook charge',
        body: 'The a-file is open. White swings the rook all the way to a8, checking the black king.',
        fen: '7k/8/8/8/8/8/R7/6K1 w - - 0 1',
        highlight: { from: 'a2', to: 'a8', check: true },
      },
      {
        kind: 'quiz',
        title: 'Rook check',
        body: 'A quick check on rooks.',
        questions: [
          { prompt: 'What is an open file?', choices: ['A column with no pawns', 'A row with two kings'], correct: 0 },
          { prompt: 'Where does a rook work best?', choices: ['On an open file', 'In the corner behind pawns'], correct: 0 },
        ],
      },
    ],
  },
  {
    id: 'check-is-power',
    slug: 'attack-check-is-power',
    title: 'Checks are powerful',
    audienceLevel: 'beginner',
    concepts: ['attack', 'piece-power'],
    steps: [
      {
        kind: 'explain',
        title: 'A check forces an answer',
        body: 'When you check the enemy king, they MUST respond — they cannot make their own plan. A checking move that also attacks a valuable piece wins material.',
        narration: 'A check makes your opponent stop and defend.',
      },
      {
        kind: 'demo',
        title: 'Watch a checking fork',
        body: 'White checks with the knight. The black king must move, and the knight captures the queen on the next move!',
        fen: '2q3k1/8/2N5/8/8/8/8/6K1 w - - 0 1',
        highlight: { from: 'c6', to: 'e7', check: true },
      },
      {
        kind: 'quiz',
        title: 'Check check',
        body: 'A quick check on checks.',
        questions: [
          { prompt: 'When you check the king, your opponent must:', choices: ['Respond to the check', 'Push a pawn'], correct: 0 },
          { prompt: 'A checking fork can win:', choices: ['A valuable piece', 'Nothing at all'], correct: 0 },
        ],
      },
    ],
  },
];
